module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/bg_mv-pc-4c5f2265529c0f684cec4ba3a9b660e4.jpg";